export default __webpack_public_path__ + "static/media/gordita-regular.31140fa5.woff2";